var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationTwocardsHorizontal = function SvgSimpleIllustrationTwocardsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__twocards-horizontal_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__twocards-horizontal_svg__st1{fill:none;stroke:#002140;stroke-width:1;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M46.224 18.69H10.038a3.384 3.384 0 0 0-3.384 3.384v18.543a3.384 3.384 0 0 0 3.384 3.384h36.187a3.384 3.384 0 0 0 3.384-3.384V22.074a3.385 3.385 0 0 0-3.385-3.384z",
    style: {
      fill: "#e4bc07"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.621 18.577H10.514a4.045 4.045 0 0 0-4.045 4.045V39.83a4.045 4.045 0 0 0 4.045 4.045h35.107a4.045 4.045 0 0 0 4.045-4.045V22.623a4.045 4.045 0 0 0-4.045-4.046z",
    className: "simple-illustration__twocards-horizontal_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.356 23.338H6.537v3.784h42.819v-3.784z",
    style: {
      fill: "#002140",
      stroke: "#002140",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.439 24.651-36.187.17a3.384 3.384 0 0 0-3.368 3.4l.087 18.543a3.384 3.384 0 0 0 3.4 3.368l36.187-.17a3.384 3.384 0 0 0 3.368-3.4l-.087-18.543a3.384 3.384 0 0 0-3.4-3.368z",
    style: {
      fill: "#ff7101"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m57.835 24.537-35.107.165a4.044 4.044 0 0 0-4.026 4.064l.081 17.207a4.045 4.045 0 0 0 4.064 4.026l35.107-.165a4.045 4.045 0 0 0 4.026-4.064l-.08-17.207a4.046 4.046 0 0 0-4.065-4.026zM22.862 45.873l5.841-.027M31.38 45.832l5.841-.027",
    className: "simple-illustration__twocards-horizontal_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m31.627 38.655-.022-4.761c0-.248-.472-.445-1.048-.445l-3.802.018c-.324 0-.63.068-.828.176l-1.292.72c-.144.081-.22.175-.22.275l.018 3.46c0 .09.067.18.189.257l.972.594c.198.122.522.189.864.189l4.131-.027c.575-.001 1.043-.208 1.038-.456z",
    style: {
      fill: "#fbccff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.748 32.957-12.685.06a2.876 2.876 0 0 0 .027 5.751l12.685-.06a2.876 2.876 0 0 0-.027-5.751z",
    style: {
      fill: "#002140"
    }
  }));
};
export default SvgSimpleIllustrationTwocardsHorizontal;